import { usePermissions } from '@/services/rbac/hooks/usePermissions';
import { canViewGantry } from '@/services/rbac/utils/gantry/canViewGantry';
import { canViewAiApps } from '@/services/rbac/utils/aiApps/canViewAiApps';
import { canViewAgentSessions } from '@/services/rbac/utils/agentSessions/canViewAgentSessions';
// import { canViewFounderDb } from '@/services/rbac/utils/founderDb/canViewFounderDb';
import { canViewInvestorDb } from '@/services/rbac/utils/investorDb/canViewInvestorDb';
import { canViewAts } from '@/services/rbac/utils/ats/canViewAts';

import {
  AGENT_SESSIONS_LINK,
  AI_APPS_LINK,
  // FOUNDER_DB_LINK,
  GANTRY_LINK,
  INVESTOR_DB_LINK,
  PL_INFRA_OS_LINK,
  NETWORK_INTELLIGENCE_DASH_LINK,
  PL_ATS_LINK,
} from '@/components/core/navbar/constants/navLinks';
import { useMemo } from 'react';

export function useGetPlInfraNavItems() {
  const { permsSet } = usePermissions();

  const hasGantryAccess = canViewGantry(permsSet);
  const hasAiAppsAccess = canViewAiApps(permsSet);
  const hasAgentSessionsAccess = canViewAgentSessions(permsSet);
  // const hasFounderDbAccess = canViewFounderDb(permsSet);
  const hasInvestorDbAccess = canViewInvestorDb(permsSet);
  const hasAtsAccess = canViewAts(permsSet);

  const hasAnyPlInfraAccess = hasGantryAccess || hasInvestorDbAccess || hasAiAppsAccess || hasAgentSessionsAccess;

  return useMemo(
    () => [
      ...(hasAiAppsAccess ? [AI_APPS_LINK] : []),
      ...(hasGantryAccess ? [GANTRY_LINK] : []),
      ...(hasAiAppsAccess ? [PL_INFRA_OS_LINK] : []),
      ...(hasAnyPlInfraAccess ? [NETWORK_INTELLIGENCE_DASH_LINK] : []),
      ...(hasAtsAccess ? [PL_ATS_LINK] : []),
      ...(hasInvestorDbAccess ? [INVESTOR_DB_LINK] : []),
      // ...(hasFounderDbAccess ? [FOUNDER_DB_LINK] : []),
      ...(hasAgentSessionsAccess ? [AGENT_SESSIONS_LINK] : []),
    ],
    [hasGantryAccess, hasAiAppsAccess, hasAgentSessionsAccess, hasInvestorDbAccess, hasAtsAccess, hasAnyPlInfraAccess],
  );
}
